import { render, staticRenderFns } from "./LockScreen.vue?vue&type=template&id=50d724ba&"
import script from "./LockScreen.vue?vue&type=script&lang=js&"
export * from "./LockScreen.vue?vue&type=script&lang=js&"
import style0 from "./LockScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
